import { render, staticRenderFns } from "./CardDeck.vue?vue&type=template&id=4241f08a&scoped=true&"
import script from "./CardDeck.vue?vue&type=script&lang=js&"
export * from "./CardDeck.vue?vue&type=script&lang=js&"
import style0 from "./CardDeck.vue?vue&type=style&index=0&id=4241f08a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4241f08a",
  null
  
)

export default component.exports